// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CfFb","newExpiryDate":"styles_newExpiryDate__Ez2xv","footer":"styles_footer__1f_uG"};